/* eslint-disable no-param-reassign */
import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';

/** creating a new instance of the ApplicationInsights class */
const appInsightsInstance = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_INSIGHT_CONNECTION_STRING || '',
    enableAutoRouteTracking: false,
  },
});

/** Adding a telemetry initializer to set the `ai.cloud.role` tag for each telemetry item, using the current environment from `REACT_APP_ENVIRONMENT` */
appInsightsInstance.addTelemetryInitializer((telemetryItem: ITelemetryItem) => {
  if (!telemetryItem.tags) {
    telemetryItem.tags = {};
  }

  if (!telemetryItem.tags['ai.cloud.role']) {
    telemetryItem.tags['ai.cloud.role'] = `web_${process.env.REACT_APP_ENVIRONMENT ?? ''}`;
  }
});

export default appInsightsInstance;
